import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { BsArrowUpRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
export default function ContactNowPopup() {

    const navigate = useNavigate();

    const [formData, setFormData] = useState({ name: "", phnumber: "", email: "", message: "" });
    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");

        try {
            const res = await fetch("https://sbbstest.in/dr.mahadevan/backend/send-mail.php", { 
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            const data = await res.json();
            console.log("Server Response:", data);

            if (data.status === "success") {
                setStatus("Email sent successfully!");
                navigate("/thank-you");
            } else {
                setStatus(data.message || "Something went wrong.");
            }
        } catch (err) {
            console.error("Error:", err);
            setStatus("Error sending email. Please try again.");
        }
    };

    return (
        <>
            <Form className="mt-4">
                <Row className="g-3">
                    <Col md={6}>
                        <Form.Control name='name' onChange={handleChange} type="text" placeholder="Enter your Name" />
                    </Col>
                    <Col md={6}>
                        <Form.Control name='phnumber' onChange={handleChange} type="text" placeholder="Enter your Phone number" />
                    </Col>
                    <Col md={12}>
                        <Form.Control name='email' onChange={handleChange} type="email" placeholder="Enter your Mail" />
                    </Col>
                    <Col md={12}>
                        <Form.Control name='message' onChange={handleChange} as="textarea" rows={3} placeholder="Enter Message" />
                    </Col>
                    {status}
                    <Col md={12}>
                        <div className="d-flex align-items-center gap-2">
                            <Button onClick={handleSubmit} variant="info" style={{ borderRadius: '12px', padding: '10px 20px', color: '#fff', fontSize: '20px', fontWeight: '600' }}>

                                Get a Solution
                            </Button>
                            <div style={{ background: '#17c7e0', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff' }}>
                                <BsArrowUpRight size={20} />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Form>
        </>
    );
}